import React, { useState, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components'
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'
import ReactLoading from 'react-loading';
import Map, { Source, Layer } from 'react-map-gl';
import KPICard from '../components/Dashboard/KPIReportCard.js';

import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';

import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';

import optc from '../optc.json'

import { reduceTotalValues } from '../helpers/routeOperationHelpers.js'

import InlineGraph from '../components/RouteOperation/InlineGraph.js';

import { useTranslation } from "react-i18next";

import {
  getAllAgencies, getRouteOperation,
  getRouteOperationNonPlani,
  getLongRouteTrace, getLongRouteStops,
  getUser, getPlannedTrips,
  getValuesPrevious,
  getTripsInfo, getTripsInfoNonPlani,
  getUserAgency, getTripTrace, getTripPoints,
  getPlanTripCumul
} from '../API';

const Styles = styled.div
  `
  padding: 1rem;

  .pagination {
    padding: 0.5rem;
  }

  th

  td { background-color: white; }

  td:nth-child(1) { 
    background: #79508f ;
    color: white }
  
`

function Table({ columns, data }) {

  const [t] = useTranslation('common');

  const [selectedRow, setSelectedRow] = useState(-1);

  const [filterInput, setFilterInput] = useState("");

  const handleFilterChange = e => {
    const value = e.target.value || undefined;
    setFilter("route_id", value); // Update this specific field
    setFilterInput(value);
  };

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },
    },
    useFilters,
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }

  // const handleCellClick = (e) => {

  // }

  // Render the UI for your table
  return (

    <>
      {headerGroups[0].headers.find((e) => { return e.id == 'route_id' }) ? <div className="row">
        <div className="col-12 text-center">
          <input
            value={filterInput}
            onChange={handleFilterChange}
            placeholder={t("routeoperation.find")}
          />
        </div>
      </div > : ''}
      <table className="table" {...getTableProps()}>
        <thead style={{ textAlign: 'center' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {

            prepareRow(row);

            return (
              <tr
                onMouseMove={(e) => handleRowHover(row)} onMouseOut={() => handleMouseOut()}
                {...row.getRowProps()}
              >
                {row.cells.map(cell => {
                  return <td
                    style={{ backgroundColor: row.id == selectedRow && cell.column.Header !== 'Ligne' ? '#D3D3D3' : '' }}
                    {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} {t('routeoperation.of')} {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | {t("routeoperation.go")}{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {t("routeoperation.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}


function RouteOperation() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const [routes, setRoutes] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: <p>{t('routeoperation.table1.route')}</p>,
        accessor: 'route_id',
        Cell: props => <div style={{ cursor: (dayjs(startDate).format('YYYY-MM-DD') == dayjs(endDate).format('YYYY-MM-DD')) ? 'pointer' : 'auto' }} onClick={(e) => handleRouteClick(e)}>{props.value}</div>,
      },
      {
        Header: <div>{t('routeoperation.table1.ptrips1')}<br /><div>{t('routeoperation.table1.ptrips2')}</div></div>,
        accessor: 'plantripcount',
      },
      {
        Header: <div>{t('routeoperation.table1.atrips1')}<br /><div>{t('routeoperation.table1.atrips2')}</div></div>,
        accessor: 'realtripcount',
      },
      {
        Header: <div>{t('routeoperation.table1.aptrips1')}<br /><div>{t('routeoperation.table1.aptrips2')}</div></div>,
        accessor: 'tripspct',
        Cell: props => <div> {props.value > 0 ? (parseFloat(props.value) * 100).toFixed(1) : 0}% </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('routeoperation.table1.pkm1')}<br /><div>{t('routeoperation.table1.pkm2')}</div></div>,
        accessor: 'planneddist',
        Cell: props => <div> {parseFloat(props.value).toFixed(0)} </div>,
      },
      {
        Header: <div>{t('routeoperation.table1.akm')}</div>,
        accessor: 'realdist',
        Cell: props => <div>
          <InlineGraph
            value={parseFloat(props.value).toFixed(0)}
            routes={routes} />
        </div>
      },
      {
        Header: <div>{t('routeoperation.table1.pakm1')}<br /><div>{t('routeoperation.table1.pakm2')}</div></div>,
        accessor: 'kmpct',
        Cell: props => <div> {props.value > 0 ? (parseFloat(props.value) * 100).toFixed(1) : 0}% </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('routeoperation.table1.phrs1')}<br /><div>{t('routeoperation.table1.phrs2')}</div></div>,
        accessor: 'plannedduration',
        Cell: props => <div> {parseFloat(props.value).toFixed(1)} </div>
      },
      {
        Header: <div>{t('routeoperation.table1.ahrs1')}<br /><div>{t('routeoperation.table1.ahrs2')}</div></div>,
        accessor: 'realduration',
        Cell: props => <div> {parseFloat(props.value).toFixed(1)} </div>
      },
      {
        Header: <div>{t('routeoperation.table1.pahrs1')}<br /><div>{t('routeoperation.table1.pahrs2')}</div></div>,
        accessor: 'durationpct',
        Cell: props => <div> {props.value > 0 ? (parseFloat(props.value) * 100).toFixed(1) : 0}% </div>,
        sortType: "custom"
      }
    ],
    [routes]
  )

  const columns2 = useMemo(
    () => [
      {
        Header: <p>{t('routeoperation.table2.trip')}</p>,
        accessor: 'trip_id',
        Cell: props => <div style={{ cursor: 'pointer' }} onClick={(e) => handleTripClick(e)}>{props.value}</div>,
      },
      {
        Header: <p>{t('routeoperation.table2.veh')}</p>,
        accessor: 'vehicle_id',
      },
      {
        Header: <p>Direction</p>,
        accessor: 'direction_id',
      },
      {
        Header: <div>{t('routeoperation.table2.pstart1')}<br /><div>{t('routeoperation.table2.pstart2')}</div></div>,
        accessor: 'plannedstarttime',
        Cell: props => <div> {props.value !== 'ND' ? new Date(props.value * 1000).toISOString().substring(11, 16) : 'ND'} </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('routeoperation.table2.astart1')}<br /><div>{t('routeoperation.table2.astart2')}</div></div>,
        accessor: 'realstarttime',
        Cell: props => <div> {props.value ? dayjs(props.value).format('HH:mm') : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.pdist1')}<br /><div>{t('routeoperation.table2.pdist2')}</div></div>,
        accessor: 'laststoploc',
        Cell: props => <div> {props.value ? (props.value / 1000).toFixed(1) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.adist1')}<br /><div>{t('routeoperation.table2.adist2')}</div></div>,
        accessor: 'dist',
        Cell: props => <div> {props.value ? (props.value / 1000).toFixed(1) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.pl1')}<br /><div>{t('routeoperation.table2.pl2')}</div></div>,
        accessor: 'plannedduration',
        Cell: props => <div> {props.value ? new Date(props.value.toString().substring(0, 5) * 1000).toISOString().substring(11, 16) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.al1')}<br /><div>{t('routeoperation.table2.al2')}</div></div>,
        accessor: 'realduration',
        Cell: props => <div> {props.value ? new Date(props.value.toString().substring(0, 5) * 1000).toISOString().substring(11, 16) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.occ1')}<br /><div>{t('routeoperation.table2.occ2')}</div></div>,
        accessor: 'avgoccupancy',
        Cell: props => <div> {props.value ? parseFloat(props.value).toFixed(3) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.otp1')}<br /><div>{t('routeoperation.table2.otp2')}</div></div>,
        accessor: 'on_time_pct',
        Cell: props => <div> {props.value ? props.value.toFixed(1) + '%' : ''} </div>,
      },
    ],
    []
  )

  const [user, setUser] = useState('');
  const [agency, setAgency] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [userAgency, setUserAgency] = useState('');

  const [route, setRoute] = useState('');
  const [routeGeom, setRouteGeom] = useState({ "type": "FeatureCollection", "features": [] });
  const [stopsGeom, setStopsGeom] = useState({ "type": "FeatureCollection", "features": [] });
  const [traceGeom, setTraceGeom] = useState({ "type": "FeatureCollection", "features": [] });
  const [tracePoints, setTracePoints] = useState({ "type": "FeatureCollection", "features": [] });

  const [tripClick, setTripClick] = useState('');

  const [reduced, setReduced] = useState({});
  const [planTrips, setPlanTrips] = useState('');
  const [planTripsCurrent, setPlanTripsCurrent] = useState('');
  const [planKms, setPlanKms] = useState('');
  const [planHours, setPlanHours] = useState('');
  const [realTrips, setRealTrips] = useState('');
  const [realKms, setRealKms] = useState('');
  const [realHours, setRealHours] = useState('');
  const [pctBar, setPctBar] = useState([]);
  const [dataType, setDataType] = useState('planifie');

  const [mapIsLoaded, setMapIsLoaded] = useState(false);
  const [zoomValue, setZoomValue] = useState(11);

  const [loading, setLoading] = useState(0);

  const mapRef = useRef();

  const [initDate, setInitDate] = useState(dayjs().add(1, 'day').format('YYYY-MM-DD'));
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [startFormat, setStartFormat] = useState('');
  const [endFormat, setEndFormat] = useState('');

  const [tripsInfo, setTripsInfo] = useState('');
  const [showTrips, setShowTrips] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKey2, setRefreshKey2] = useState(0);
  const [refreshKey3, setRefreshKey3] = useState(0);
  const [refreshKey4, setRefreshKey4] = useState(0);
  const [refreshKey5, setRefreshKey5] = useState(0);

  // Sans clé dans l'array, la fonction est exécutée 1 seule fois
  useEffect(() => {

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency()
      .then(response => {
        setUserAgency(response);
      })

  }, []);


  useEffect(() => {

    if (dataType == 'planifie') {

      setLoading(1);

      if (startFormat == '' || startFormat == dayjs().format('YYYY-MM-DD')) {

        //TODAY
        getRouteOperation(agency, startFormat, endFormat)
          .then(routeResponse => {

            const dataReduced = reduceTotalValues(routeResponse)[0];
            setReduced(dataReduced);

            setRealTrips(dataReduced.realTrips);
            setRealKms(dataReduced.realKM.toFixed(0));
            setRealHours(dataReduced.realDuration.toFixed(0));

            // setPlanTripsCurrent(dataReduced.planTrips);
            // setPlanKms(dataReduced.planKM);
            // setPlanHours(dataReduced.planDuration);

            setRoutes(routeResponse);

            return Promise.all([
              dataReduced,
              getPlannedTrips(agency),
              getPlanTripCumul(agency)
            ]);
          })
          .then(([
            dataReduced,
            plannedTripsResponse,
            tripCumulResponse
          ]) => {

            setPlanTrips(plannedTripsResponse[0].sum);

            setPlanTripsCurrent(tripCumulResponse[0].plantripcount);
            setPlanKms(tripCumulResponse[0].plandist);
            setPlanHours(tripCumulResponse[0].planduration);

            setPctBar([{
              name: 'trips',
              plan: plannedTripsResponse[0].sum,
              real: dataReduced.realTrips
            }]);

            setLoading(0);

          })
          .catch(error => {
            // Handle error if any of the async operations fail
            console.error("Error:", error);
          });
      }
      else {
        //PREVIOUS DAYS
        let previous = 1;

        Promise.all([
          getRouteOperation(agency, startFormat, endFormat, previous),
          getValuesPrevious(agency, startFormat, endFormat)
        ])
          .then(([routeResponse, valuesResponse]) => {
            setRoutes(routeResponse);

            setPlanTripsCurrent(valuesResponse[0].plannedtrips);
            setPlanKms(valuesResponse[0].plannedvehkms);
            setPlanHours(valuesResponse[0].plannedvehhours);
            setRealTrips(valuesResponse[0].rttrips);
            setRealKms(valuesResponse[0].rtvehkms);
            setRealHours(valuesResponse[0].rtvehhours);

            setPctBar([{
              name: 'trips',
              plan: valuesResponse[0].plannedtrips,
              real: valuesResponse[0].rttrips
            }]);

            setLoading(0);
          })
          .catch(error => {
            // Handle error if any of the async operations fail
            console.error("Error:", error);
          });

      }
    }

  }, [refreshKey]);


  useEffect(() => {

    if (dataType == 'planifie' && showTrips == true) {
      setLoading(1);

      getTripsInfo(agency, startFormat, route)
        .then((response) => {
          setTripsInfo(response);
          setLoading(0);
        })
    } else if (dataType == 'non-planifie' && showTrips == true) {
      setLoading(1);

      getTripsInfoNonPlani(agency, startFormat, route)
        .then((response) => {
          setTripsInfo(response);
          setLoading(0);
        })
    }

  }, [refreshKey4])


  useEffect(() => {

    if (tripClick) {

      setTraceGeom({ "type": "FeatureCollection", "features": [] });
      setTracePoints({ "type": "FeatureCollection", "features": [] });

      getTripTrace(agency, startFormat, tripClick)
        .then((response) => {
          setTraceGeom(response[0].jsonb_build_object);
        })
      getTripPoints(agency, startFormat, tripClick)
        .then((response) => {
          setTracePoints(response[0].jsonb_build_object)
        })
    }

  }, [refreshKey5])


  useEffect(() => {

    if (dataType == 'non-planifie') {

      let previous = (startFormat == '' || startFormat == dayjs().format('YYYY-MM-DD')) ? 0 : 1;

      //TODAY
      getRouteOperationNonPlani(agency, startFormat, endFormat, previous)
        .then(routeResponse => {

          const dataReduced = reduceTotalValues(routeResponse)[0];
          setReduced(dataReduced);

          setRealTrips(dataReduced.realTrips.toFixed(0));
          setRealKms(dataReduced.realKM.toFixed(0));
          setRealHours(dataReduced.realDuration.toFixed(0));

          setRoutes(routeResponse);

          setPlanTrips(0);
          setPlanTripsCurrent(0);
          setPlanKms(0);
          setPlanHours(0);

          setPctBar([{
            name: 'trips',
            plan: 0,
            real: dataReduced.realTrips
          }]);

          setLoading(0);

        })

    }

  }, [refreshKey2])


  useEffect(() => {
    zoomToLocation();
  }, [refreshKey3])


  function handleRouteClick(e) {

    if (dayjs(startDate).format('YYYY-MM-DD') == dayjs(endDate).format('YYYY-MM-DD')) {

      setRoute(e.target.innerHTML);
      setTripClick('');
      // setTraceGeom({ "type": "FeatureCollection", "features": [] });
      zoomToLocation();

      setShowTrips(true);
      setRefreshKey3(oldKey => oldKey + 1);
      setRefreshKey4(oldKey => oldKey + 1);
    }
  }

  const handleTripClick = (e) => {

    // setTraceGeom({ "type": "FeatureCollection", "features": [] });
    setTripClick(e.target.innerHTML);
    setRefreshKey5(oldKey => oldKey + 1);
  }

  const handleAgencySelect = (e) => {
    setLoading(1);
    setAgency(e.target.value);
    // setTraceGeom({ "type": "FeatureCollection", "features": [] });
    setRouteGeom({ "type": "FeatureCollection", "features": [] });
    setStopsGeom({ "type": "FeatureCollection", "features": [] });
    setPlanTrips('');
    setPlanKms('');
    setPlanHours('');
    setRealTrips('');
    setRealKms('');
    setRealHours('');
    setTripsInfo('');
    setTripClick('');
    setRefreshKey(oldKey => oldKey + 1);

  }

  const handleOnLoad = () => {
    setMapIsLoaded(true);

  }


  const handleChangeDate = (dates) => {

    const [start, end] = dates;

    if (dayjs(start).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')) {
      setInitDate(dayjs().format('YYYY-MM-DD'));
    }

    setStartDate(start);
    setEndDate(end);
    setEndFormat('');


    if (end !== null) {

      //setDataType('planifie');

      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');

      setRoute('');
      setTripsInfo('');
      setTripClick('');
      setRouteGeom({ "type": "FeatureCollection", "features": [] });
      setStopsGeom({ "type": "FeatureCollection", "features": [] });

      setShowTrips(false);

      setStartFormat(formatstart);
      setEndFormat(formatend);
      setInitDate(dayjs().add(1, 'day').format('YYYY-MM-DD'));

      setRefreshKey(oldKey => oldKey + 1);
      setRefreshKey2(oldKey => oldKey + 1);
      setRefreshKey4(oldKey => oldKey + 1);
    }

  };


  const handlePlaniClick = (e) => {
    if (e.target.value == 'non-planifie') {
      setDataType('non-planifie');
      setRoute('');
      setTripClick('');
      setRefreshKey2(oldKey => oldKey + 1);
    } else {
      setDataType('planifie');
      setRoute('');
      setTripClick('');
      setRefreshKey(oldKey => oldKey + 1);
    }

  }


  const zoomToLocation = () => {
    if (mapIsLoaded == true && user !== 'admin') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[1],
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[0]
        ],
        duration: 2000,
        zoom: 9
      });
    } else if (mapIsLoaded == true && user == 'admin') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == agency).latlong[1],
          optc.optc.find((e) => e.operateur == agency).latlong[0]
        ],
        duration: 2000,
        zoom: 9
      });
    }

  }

  return (
    user && userAgency && routes && pctBar.length > 0 ?
      <>
        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm"></div>
          <h1 id="page-title" className="display-5">{t("routeoperation.title")}</h1>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          <div className="row text-center pt-3 pb-2">

            <DatePicker
              selected={startDate}
              onChange={handleChangeDate}
              locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
              inline
              startDate={startDate}
              endDate={endDate}
              selectsRange
              excludeDateIntervals={[
                {
                  start: new Date('2000-01-01'),
                  end: new Date('2023-07-01')
                },
                {
                  start: new Date(initDate),
                  end: new Date('2030-12-31')
                },
              ]}
            />

          </div>


          <div className="row justify-content-center">
            <div className="col-lg col-sm-12 text-center">

              {Array.isArray(userAgency) && userAgency.length > 1 ?
                <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>
                  <div className="row justify-content-center">
                    <div className="col-lg-4 col-sm-12">
                      <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                        <option defaultValue>Opérateur</option>
                        {userAgency.map((e) => (
                          <option value={e} key={e}
                          >{e}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div> : ''}

            </div>
          </div>


          <div className="row justify-content-center">
            <div className="col text-center pt-3">
              <h3>{(startFormat == endFormat || endFormat == '') ?
                dayjs(startDate).format('YYYY-MM-DD') :
                'Du ' + dayjs(startDate).format('YYYY-MM-DD') + ' au ' + dayjs(endDate).format('YYYY-MM-DD')}</h3>
              {/* <h5 className="display-7">Inclus les départs après minuit</h5> */}
            </div>
          </div>


          {(dayjs(startDate).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')) && (endDate !== null) && (dataType == 'planifie') ?
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-6 col-sm-12 text-center">
                <div>{t("routeoperation.progress")}</div>
                <ResponsiveContainer width="100%" height={100}>
                  <BarChart
                    width={500}
                    height={300}
                    data={pctBar}
                    layout="vertical"
                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                    barGap={-50}
                  >
                    <XAxis type="number" domain={[0, 'dataMax']} hide />
                    <YAxis type="category" hide />
                    {/* <Tooltip
                            content={<CustomTooltip />}
                          /> */}
                    <Bar dataKey="plan" fill="#ffffff" stroke="black" barSize={50} />
                    <Bar dataKey="real" fill="#a986bb" barSize={50} />
                    <text
                      x='50%'
                      y='45%'
                      dy={+12}
                      style={{ fontSize: 20, fill: '#000000' }}
                      width={200}
                      scaletofit="true"
                      textAnchor='middle'
                      verticalanchor='middle'
                    >
                      {realTrips + '/' + planTrips + ' (' + (realTrips / planTrips * 100).toFixed(0) + '%)'}
                    </text>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            : ''
          }

          {dataType == 'planifie' ?
            // <div className="row no-gutters align-items-center justify-content-center">
            <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 justify-content-center">
              <KPICard
                kpi={realTrips && planTripsCurrent ? parseFloat(realTrips / planTripsCurrent * 100).toFixed(1) + '%' : 'Chargement'}
                desc={<><div>{t("home.kpi.trips")}</div><div>{
                  realTrips && planTripsCurrent ? realTrips + ' / ' + planTripsCurrent : 'Chargement...'}</div></>}
              />
              <KPICard
                kpi={realKms && planKms ? parseFloat(realKms / planKms * 100).toFixed(1) + '%' : 'Chargement...'}
                desc={<><div>{t("home.kpi.km")}</div>
                  <div>{realKms && planKms ?
                    realKms + ' / ' + parseFloat(planKms).toFixed(0) : 'Chargement'}</div>
                </>}
              />
              <KPICard
                kpi={realHours && planHours ? parseFloat(realHours / planHours * 100).toFixed(1) + '%' : 'Chargement...'}
                desc={<><div>{t("home.kpi.hours")}</div>
                  <div>{realHours && planHours ?
                    realHours + ' / ' + parseFloat(planHours).toFixed(0) : 'Chargement'}</div></>}
              />
            </div>
            :
            <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 justify-content-center">
              <KPICard
                kpi={realTrips ? realTrips : 'Chargement...'}
                desc={<><div>{t('routeoperation.table1.atrips1')} <br/> {t('routeoperation.table1.atrips2')}</div></>}
              />
              <KPICard
                kpi={realKms ? realKms : 'Chargement...'}
                desc={<><div>{t('routeoperation.table1.akm')}</div></>}
              />
              <KPICard
                kpi={realHours ? realHours : 'Chargement...'}
                desc={<><div>{t('routeoperation.table1.ahrs1')} <br/> {t('routeoperation.table1.ahrs2')}</div></>}
              />
            </div>
          }


          <div className="row justify-content-center">
            <div className="col-lg col-sm-12 text-center">
              <FormControl>
                <FormLabel>Service :</FormLabel>
                <RadioGroup
                  row
                  defaultValue="planifie"
                  aria-labelledby="row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel checked={dataType === 'planifie'} onChange={(e) => handlePlaniClick(e)} value="planifie" control={<Radio />} label={t("routeoperation.planned")} />
                  <FormControlLabel checked={dataType === 'non-planifie'} onChange={(e) => handlePlaniClick(e)} value="non-planifie" control={<Radio />} label={t("routeoperation.unplanned")} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          <div className="col pt-2">
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container">
                <div className="row justify-content-center">
                  <div className="col">
                    <Styles>
                      <Table columns={columns} data={routes} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {loading == 0 ? '' :
            <div className="routespinner">
              <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
            </div>}


          {route && tripsInfo && showTrips == true ? <div className="col pt-2">
            <h3 className="text-center pt-2 pb-2">{t("routeoperation.route")} {route}</h3>
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container">
                <div className="row justify-content-center">
                  <div className="col">
                    <Styles>
                      <Table columns={columns2} data={tripsInfo} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div> : ''}


          <div className="row justify-content-center pt-3">
            <div className="col-lg-12 col-sm-12 pt-3 pb-4">
              <h3 className="text-center">{tripClick ? t("routeoperation.route") + route + t("routeoperation.trip") + tripClick : ''}</h3>
              <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                <Map
                  initialViewState={{
                    latitude: 45.556827,
                    longitude: -73.662362,
                    zoom: zoomValue
                  }}
                  style={{ width: '100%', height: '40vh' }}
                  ref={ref => mapRef.current = ref && ref.getMap()}
                  onLoad={handleOnLoad}
                  mapStyle="mapbox://styles/wdoucetk/cjun8whio1ha21fmzxt8knp7k"
                  mapboxAccessToken={process.env.REACT_APP_MAPBOX_KEY}
                  attributionControl={false}
                >


                  <Source
                    id={"stops"}
                    type="geojson" data={tripClick ? { "type": "FeatureCollection", "features": [] } : stopsGeom}
                  >
                    <Layer {...{
                      "id": "stops",
                      "type": "circle",
                      "source": "stops",
                      "paint": {
                        "circle-radius": 3,
                        "circle-color": "white",
                        "circle-stroke-width": 1,
                        "circle-stroke-color": user == 'admin' ?
                          optc.optc.find((e) => e.operateur == agency).color :
                          optc.optc.find((e) => e.operateur == userAgency[0]).color
                      }
                    }} />
                  </Source>
                  <Source
                    id={"points"}
                    type="geojson" data={tripClick ? tracePoints : { "type": "FeatureCollection", "features": [] }}
                  >
                    <Layer {...{
                      "id": "stop-points",
                      "type": "circle",
                      "source": "points",
                      "paint": {
                        "circle-radius": 3,
                        "circle-color": '#4d0077',
                        "circle-stroke-width": 1,
                        "circle-stroke-color": '#4d0077'
                      }
                    }} />
                  </Source>
                  <Source
                    id={"route_dir"}
                    type="geojson" data={tripClick ? traceGeom : { "type": "FeatureCollection", "features": [] }}
                  >
                    <Layer {...{
                      "beforeId": "stops",
                      "id": "trace",
                      'type': 'line',
                      "source": "route_dir",
                      "layout": {
                        "line-join": "round",
                        "line-cap": "round",
                        "visibility": "visible"
                      },
                      "paint": {
                        'line-width': 1,
                        'line-color': user == 'admin' ?
                          optc.optc.find((e) => e.operateur == agency).color :
                          optc.optc.find((e) => e.operateur == userAgency[0]).color
                      }
                    }} />
                  </Source>
                </Map>
              </div>
            </div>
          </div>


        </div>
      </> :
      <>
        <div className="d-flex justify-content-center">
          <div className="row">
            <div className="col-sm">
              <h1 className="display-5">{t('data.loading')}</h1>
              <div className="d-flex justify-content-center">
                <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
              </div>
            </div>
          </div>
        </div>
      </>
  )
}

export default RouteOperation